module.exports = __webpack_public_path__ + "static/img/logo_03_03.aee60cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimg/images/logo_03_03.png
// module id = xJWy
// module chunks = 0